import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=4c89ce60&scoped=true"
import script from "./legal.ts?vue&type=script&lang=ts&external"
export * from "./legal.ts?vue&type=script&lang=ts&external"
import style0 from "./Legal.vue?vue&type=style&index=0&id=4c89ce60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c89ce60",
  null
  
)

export default component.exports